import React from 'react'

function NoAppointment() {
  return (
    <div className="alert alert-info d-flex align-items-center p-5">
        <div className="bi bi-info-circle-fill flex-shrink-0 me-3" style={{fontSize: '2rem'}}></div>
        <div>
          <h2 className="mb-1">No Apppointment Found</h2>
          <span>There is no appointment booked for the selected date.</span>
        </div>
      </div>
  )
}

export default NoAppointment
